export const equipmentCategoryLabels: Record<string, string> = {
  excavation: '挖掘机械',
  transport: '运输机械',
  lifting: '起重机械',
  concrete: '混凝土机械',
  compaction: '压实机械',
  road: '路面机械',
};

export const materialCategoryLabels: Record<string, string> = {
  水泥: '水泥类',
  钢筋: '钢筋类',
  砂石: '砂石类',
  砖块: '砖块类',
  混凝土: '混凝土类',
  防水材料: '防水材料',
  保温材料: '保温材料',
  装饰材料: '装饰材料',
  管材: '管材类',
  电线电缆: '电线电缆',
  乔木: '乔木',
  灌木: '灌木',
  草本: '草本植物',
  草坪: '草坪',
  土壤: '土壤类',
  肥料: '肥料类',
  园艺材料: '园艺材料',
  铺装材料: '铺装材料',
};

export function getEquipmentCategoryLabel(category: string): string {
  if (!category) return '';
  const key = category.trim();
  return equipmentCategoryLabels[key] || key;
}

export function getMaterialCategoryLabel(category: string): string {
  if (!category) return '';
  const key = category.trim();
  return materialCategoryLabels[key] || key;
}

export function normalizeEquipmentCategory(category: string): string {
  if (!category) return '';
  const key = category.trim();
  if (equipmentCategoryLabels[key]) return key;
  const mapped = Object.entries(equipmentCategoryLabels).find(([, label]) => label === key);
  return mapped ? mapped[0] : key;
}

export function normalizeMaterialCategory(category: string): string {
  if (!category) return '';
  const key = category.trim();
  if (materialCategoryLabels[key]) return key;
  const mapped = Object.entries(materialCategoryLabels).find(([, label]) => label === key);
  return mapped ? mapped[0] : key;
}

export const plantTypeLabels: Record<string, string> = {
  tree: '乔木',
  shrub: '灌木',
  herb: '草本植物',
  grass: '草坪',
  flower: '花卉',
};

export function getPlantTypeLabel(type: string): string {
  if (!type) return '';
  const key = type.trim();
  return plantTypeLabels[key] || key;
}

export function normalizePlantType(input: string): string {
  if (!input) return '';
  const key = input.trim();
  if (plantTypeLabels[key]) return key;
  const mapped = Object.entries(plantTypeLabels).find(([, label]) => label === key);
  return mapped ? mapped[0] : key;
}
